import { ENGLISH_TRANSLATIONS } from './en';
import { SPANISH_TRANSLATIONS } from './es';

export const ALL_TRANSLATIONS = {
  en: ENGLISH_TRANSLATIONS,
  es: SPANISH_TRANSLATIONS,
};
